if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if(!this.form) {
        this.form = this;
      };
      if (this.form.querySelector('[name=id]')) this.form.querySelector('[name=id]').disabled = false; // wc - allowed forms with mupliple products
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.simpleGWP = this.querySelector('simple-gwp-free-product') || null;
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.gwpJsonElement = this.querySelector('[data-subscription-gwp-json]');
      this.subscriptionGwpData = JSON.parse(this.gwpJsonElement ? this.gwpJsonElement.innerHTML : '{}');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      // wc - checks if added products are a set
      if (document.querySelector('variant-radios')) {
        this.wcCheckForProductSet(formData);
      }

      if (this.subscriptionGwpData.hasSubscriptionFreeItem && formData.get('selling_plan')) {
        const cartItems = await this.getCartItems();
        this.subscriptionGwpData.gwpProductList.forEach(product => {
          if (product.tags.includes('subscription_free_item') && !this.isProductInCart(cartItems, product.id)) {
            const existingGiftItem = cartItems.find(item => item.properties && item.properties._is_subscription_gift && item.id === product.variants[0].id);
            if (!existingGiftItem) {
              formData.append(`items[${product.variants[0].id}][id]`, product.variants[0].id);
              formData.append(`items[${product.variants[0].id}][quantity]`, 1);
              formData.append(`items[${product.variants[0].id}][properties][_is_subscription_gift]`, true);
            }
          }
        });
      }

      if (this.simpleGWP) {
        this.formatFormDataForSimpleGWP(formData);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              // wc - show pre-cart condition
              if (this.cart.dataset.wcShowPreCart === 'true') this.wcDisplayAddedCartItem();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          });
    }

    formatFormDataForSimpleGWP(data) {
      const simpleGWPvariant = this.simpleGWP.getAttribute('simple-free-product-id') || null;
      const originalProductQuantity = data.get("quantity") || 1;

      if (!simpleGWPvariant) return data;

      data.set(`properties[simple_free_item]`, simpleGWPvariant);
      data.set(`items[${simpleGWPvariant}][id]`, simpleGWPvariant);
      data.set(`items[${simpleGWPvariant}][quantity]`, originalProductQuantity);

      return data;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    async getCartItems() {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.items;
    }

    isProductInCart(cartItems, productId) {
      return cartItems.some(item => item.id === productId && item.properties && item.properties._is_subscription_gift);
    }

    wcCheckForProductSet(data) {
      this.setId = false;
      let selectedId = this.querySelector('input[name="id"]').value;
      let selectedLabel = document.querySelector('variant-radios').querySelector(`label[data-wc-variant-id="${selectedId}"]`);
      let setId = Math.floor(Math.random() * 100000);

      if (!selectedLabel) return;
      if (!selectedLabel.dataset.wcSetProductsId) return;

      this.setId = setId;
      data.delete('id');

      selectedLabel.dataset.wcSetProductsId.split(',').forEach((productId, i) => {
        if (i == 0) {
          data.set(`items[${i}][properties][_main_product]`, true);
        }
        data.set(`items[${i}][id]`, productId);
        data.set(`items[${i}][quantity]`, data.get('quantity'));
        data.set(`items[${i}][properties][Set]`, selectedLabel.dataset.wcSetName);
        data.set(`items[${i}][properties][_set_id]`, setId);
        data.set(`items[${i}][properties][_product_url]`, selectedLabel.dataset.wcSetUrl);
        data.set(`items[${i}][properties][_image]`, selectedLabel.dataset.wcSetImage);
        data.set(`items[${i}][properties][_product_names]`, selectedLabel.dataset.wcSetProductsName);
        data.set(`items[${i}][properties][_product_ids]`, selectedLabel.dataset.wcSetProductsId);
        data.set(`items[${i}][properties][_set_price]`, selectedLabel.dataset.wcSetProductsPrice);
      });

      return data;
    }

    wcDisplayAddedCartItem() {
      const wcAddedItemIds = [...this.form.querySelectorAll('input')].filter(input => {
        return input.name.includes('id');
      }).map(input => input.value);
      const wcAddedItemId = wcAddedItemIds.join(',');

      const wcCartDrawer = document.querySelector('cart-drawer');
      if (wcCartDrawer && !this.form.querySelector('[name="properties[_giftId]"]')) {
        wcCartDrawer.dataset.wcAddedItemId = wcAddedItemId;
        wcAddedItemIds.forEach(itemId => {
          const wcShowAddedItem = document.createElement("style");
          wcShowAddedItem.innerText = `cart-drawer[data-wc-added-item-id="${wcAddedItemId}"] .cart-item[data-wc-item-id="${itemId}"]{display:grid!important}`;
          this.cart.appendChild(wcShowAddedItem);
        });
      }

      if (this.setId) {
        wcCartDrawer.dataset.wcAddedSetId = this.setId;
        const wcShowAddedItem = document.createElement("style");
        wcShowAddedItem.innerText = `cart-drawer[data-wc-added-set-id="${this.setId}"] .cart-item[data-wc-set-id="${this.setId}"]{display:grid!important}`;
        this.cart.appendChild(wcShowAddedItem);
      } else {
        wcCartDrawer.dataset.wcAddedSetId = '';
      }

      if (document.querySelector('.wc-free-shipping')) document.querySelector('.wc-free-shipping').style.display = 'none';
      if (document.querySelector('.wc-gwtp__container')) document.querySelector('.wc-gwtp__container').style.display = 'none';
      if (document.querySelector('.wc-sample__container')) document.querySelector('.wc-sample__container').style.display = 'none';
    }
  });
}
